import styled from '@emotion/styled';

const RatingContainer = styled.data`
  display: inline-flex;
  column-gap: 1px;
`;

export { RatingContainer };
